<template>
  <div class="offers-row">
      <div class="row g-0 px-4 mx-2 fs-4 txt-black">
          <div class="col-12 col-md-3 py-3 px-3">{{this.offer.Merchant.Name}}</div>
          <div class="col-12 col-md-5 py-3 px-3">{{this.offer.Headline}}</div>
          <div class="col-12 col-md-2 py-3 px-3 text-center"><a href="javascript:;" @click.prevent="showOfferModal" class="txt-black text-decoration-underline">View Details</a></div>

          <div class="col-12 col-md-2 px-3 text-center" v-if="this.offer.ActiveSc == 'AVAILABLE' && !this.activatedNow">
              <a @click="showEnrollCardOrActivate" class="button orange tinysize full-width modal-link">Activate</a>
          </div>
          <div class="col-12 col-md-2 px-3 text-center" v-if="this.offer.ActiveSc != 'AVAILABLE' || this.activatedNow">
              <a href="javascript:" class="button pink activated tinysize small mTop10 modal-link">Activated</a>
          </div>

      </div>
      <offer-details-component v-if="this.offer && this.offer.OfferProvider != 'rewards_network'" @reload="reload" @showEnrollCardOrActivate="showEnrollCardOrActivate" :activatedNow="this.activatedNow" :offer="this.offer"></offer-details-component>
      <offer-calendar-details-component v-if="this.offer && this.offer.OfferProvider == 'rewards_network'" @reload="reload" @showEnrollCardOrActivate="showEnrollCardOrActivate" :activatedNow="this.activatedNow" :offer="this.offer"></offer-calendar-details-component>

  </div>
</template>

<script>
    import OfferCalendarDetailsComponent from './modals/OfferCalendarDetailsComponent.vue';
    import OfferDetailsComponent from './modals/OfferDetailsComponent.vue';
    export default {
        components: { OfferDetailsComponent, OfferCalendarDetailsComponent },
        name: "OffersRowComponent",
        props: ['offer'],
        data() {
            return {
                user: null,
                userEnrolledInAll: this.getUserEnrolledInAll(),
                activatedNow: false,
            }
        },
        methods: {
            activate() {
                if(this.offer.OfferId) {
                    axios.post(this.apiEndPoints.activateOffer, {
                        offer_id: this.offer.OfferId
                    }).then(response => {
                        if (response.data && response.data.ActivationId) {
                            if(response.data.Status && response.data.Status == 'ACTIVATED') {
                                this.activatedNow = true;
                            } else {
                                this.activatedNow = false;
                            }
                        }
                    }).catch(error => {

                        if (error.response && error.response.status && (error.response.status == 401 || error.response.status == 419)) {

                        }

                        return false;
                    });
                }

            },
            showOfferModal() {
                $.colorbox({
                    inline: true,
                    href: this.offer.OfferProvider != 'rewards_network' ? '#offer-details-modal-' + this.offer.OfferId : '#offer-calendar-modal-' + this.offer.OfferId,
                    width: '80%',
                    maxWidth: '800px',
                    opacity: '0.90',
                    closeButton: false,
                    onComplete: function () {
                        setTimeout(function () {
                            $.colorbox.resize();
                        }, 500);
                    }
                });
            },

            reload(user) {
                this.user = user;
                this.userEnrolledInAll = this.getUserEnrolledInAll();
                this.activatedNow = true;
            },

            getUserEnrolledInAll() {
                if(localStorage.getItem('user_obj')) {
                    this.user = JSON.parse(localStorage.getItem('user_obj'));
                }
                return (this.user && this.user.id && this.user.total_aggregators_enrolled_in == this.user.total_aggregators_count && this.user.total_aggregators_count > 0);
            },

            showEnrollCardOrActivate() {

                this.userEnrolledInAll = this.getUserEnrolledInAll();
                if(this.userEnrolledInAll) {
                    this.activate();
                } else {
                    $.colorbox({
                        inline: true,
                        href: '#enroll-cards-modal-' + this.offer.OfferId,
                        width: '80%',
                        maxWidth: '800px',
                        opacity: '0.90',
                        closeButton: false,
                        onComplete: function () {
                            setTimeout(function () {
                                $.colorbox.resize();
                            }, 500);
                        }
                    });
                    $('.modal-close').on('click', function (e) {
                        e.preventDefault();
                        $.colorbox.close();
                    });
                }
            },

        },
        mounted() {

            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
            }

            $('.modal-close').on('click', function (e) {
                e.preventDefault();
                $.colorbox.close();
            });
        },
    }
</script>


